import {createSlice} from '@reduxjs/toolkit';
import {TreatmentDetailsDto} from 'src/shared/services/patient/dto/treatment-details-dto';
import {ClearAlignerPlanDetailsDto} from 'src/shared/services/treatment-order/dto/clear-aligner-plan-details-dto';
import {TreatmentTypesDto} from 'src/shared/services/treatment-types/dto/treatment-type-dto';

interface TreatmentsInitialState {
  treatmentsList: Array<TreatmentDetailsDto> | undefined;
  treatmentDetails: TreatmentDetailsDto | undefined;
  isTreatmentsListLoading: boolean | undefined;
  clearAlignerPlanDetails?: ClearAlignerPlanDetailsDto;
  treatmentTypesDetails?: TreatmentTypesDto | undefined;
}

const initialState: TreatmentsInitialState = {
  treatmentsList: [],
  treatmentDetails: undefined,
  isTreatmentsListLoading: false,
  clearAlignerPlanDetails: undefined,
  treatmentTypesDetails: undefined,
};

const treatmentsSlice = createSlice({
  name: 'treatments',
  initialState: initialState,
  reducers: {
    setTreatmentsList: (state, action) => {
      state.treatmentsList = action.payload;
    },
    setTreatmentDetails: (state, action) => {
      state.treatmentDetails = action.payload;
    },
    setIstreatmentsListLoading: (state, action) => {
      state.isTreatmentsListLoading = action.payload;
    },
    setClearAlignerPlanDetails: (state, action) => {
      state.clearAlignerPlanDetails = action.payload;
    },
    setTreatmentTypesDetails: (state, action) => {
      state.treatmentTypesDetails = action.payload;
    },
  },
});

export const {
  setTreatmentsList,
  setTreatmentDetails,
  setIstreatmentsListLoading,
  setClearAlignerPlanDetails,
  setTreatmentTypesDetails,
} = treatmentsSlice.actions;

export default treatmentsSlice.reducer;
